import { render } from "./EmployeeLicense.vue?vue&type=template&id=75b434e8"
import script from "./EmployeeLicense.vue?vue&type=script&lang=js"
export * from "./EmployeeLicense.vue?vue&type=script&lang=js"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__